import { render, staticRenderFns } from "./EditStatusAutomationModal.vue?vue&type=template&id=32b11fbb&scoped=true&"
import script from "./EditStatusAutomationModal.vue?vue&type=script&lang=js&"
export * from "./EditStatusAutomationModal.vue?vue&type=script&lang=js&"
import style0 from "./EditStatusAutomationModal.vue?vue&type=style&index=0&id=32b11fbb&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32b11fbb",
  null
  
)

export default component.exports